import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  createCasinoStart,
  deleteCasinoSubCategoriesStart,
  getAllCasinoGamesStart,
  getAllCasinoProvidersStart,
  getSuperAdminGameCategoryStart,
  getSuperAdminGameSubCategoryStart,
  handleSuperAdminPopularGameStart,
  updateCasinoStart,
  updateGameThumbnailURLStart,
  updateSACasinoGamesStatusStart,
  updateStatusStart,
  addCasinogameCategoryStart,
  getCasinoGamesCategoryCountStart
} from "../../../../store/redux-slices/superAdminCasinoManagement";
import useDidMountEffect from "../../../../utils/useDidMountEffect";
import { toast } from "../../../../components/Toast"

// import { toast } from "../../../components/Toast"


const useCasinoGamesListing = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isInitialRender = useDidMountEffect();

  const [limit, setLimit] = useState(15);
  const [page, setPage] = useState(1);
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState("");
  const [show, setShow] = useState(false);
  const [data, setData] = useState();
  const [type, setType] = useState("");
  const [search, setSearch] = useState("");
  const [casinoGameId, setCasinoGameId] = useState();
  const [selectedCasinoGameId, setSelectedCasinoGameId] = useState();
  const [active, setActive] = useState("");
  const [status, setStatus] = useState();
  const [statusShow, setStatusShow] = useState(false);
  const [casinoBonusModal, setCasinoBonusModal] = useState(false);
  const [selectedProvider, setSelectedProvider] = useState("");
  const [name, setName] = useState();
  const [bonusFilter, setBonusFilter] = useState("");
  const [imageModal, setImageModal] = useState({
    isOpen: false,
    url: ""
  })
  const [isEnanbleAssignCategory, setIsEnableAssignCategory] = useState({
    enable: false
  });
  const [popularModal, setPopularModal] = useState({
    isOpen: false,
    title: "",
    subTtitle: "",
    data: ""
  })

  const [categoryDropdownOptions, setCategoryDropdownOptions] = useState([]);
  const [selectedCategoryOption, setSelectedctegoryOptions] = useState("");
  const [isOpenAssignCategoryModal, setIsOpenAssignCategoryModal] = useState({ isOpen: false, selectedData: "" })

  const { loading, casinogameLoading, casinoGamesData, gameSubCategory, casinoProvidersData, gameCategory, loadingAddCategory, gamesCountData, loadingGamesCount } =
    useSelector((state) => state.superAdminCasino);
  const totalPages = Math.ceil(casinoGamesData?.count / limit);
  const totalCount = casinoGamesData?.count;


  const handleStatusShow = (id, status, myName) => {
    setCasinoGameId(id);
    setStatus(!status);
    setName(myName);
    setStatusShow(true);
  };
  const getCategoryName = (id) =>
    gameSubCategory?.rows.find((val) => val.gameSubCategoryId === id)?.name?.EN;

  const getProviderName = (id) => {
    return casinoProvidersData?.rows.find((val) => val.casinoProviderId === id)
      ?.name;
  };

  useEffect(() => {
    if (gameCategory?.data?.length > 0) {

      const dropdownOptions = gameCategory?.data?.map(item => ({
        value: item.gameCategoryId,
        label: `${item.name}`,
        gameLimit: item.gameLimit,
        categoryType: item.categoryType
      }));

      setCategoryDropdownOptions(dropdownOptions);

    }


  }, [gameCategory])

  const handleUpdateCategoryChange = (e) => {
    dispatch(getCasinoGamesCategoryCountStart({
      data: { id: e.target.value }, onSuccess: () => {
        setIsEnableAssignCategory({ enable: true })
      },
      onError: (error) => {
        toast(`Can't add game to ${error?.categoryName} category. Limit: ${error?.gameLimit || 0}, Total games: ${error?.featuredGameCount || 0}`, "error");
        setIsEnableAssignCategory({ enable: false })
      }
    }))
    setSelectedctegoryOptions(e.target.value)
  }

  console.log(isEnanbleAssignCategory, "isEnanbleAssignCategoryisEnanbleAssignCategory")

  const onSubmitAddCasinoGameCategory = () => {
    dispatch(
      addCasinogameCategoryStart({
        data: {
          gameCategoryId: Number(selectedCategoryOption),
          casinoGameId: isOpenAssignCategoryModal?.selectedData?.id
        },
        onSuccess: () => {
          setIsOpenAssignCategoryModal({ isOpen: false, selectedData: "" })
          setSelectedctegoryOptions("")


          dispatch(
            getAllCasinoGamesStart({
              limit,
              pageNo: page,
              casinoCategoryId: selectedSubCategoryId,
              search,
              isActive: active,
              tenantId: "",
              selectedProvider,
            })
          );
        },
      })
    );
  }

  const handleDeleteItems = (casinoGameId) => {
    dispatch(
      deleteCasinoSubCategoriesStart({
        data: {
          code: "CASINO_GAME",
        },
        limit,
        pageNo: page,
        casinoGameId: casinoGameId,
        casinoCategoryId: selectedSubCategoryId,
        search,
        isActive: active,
        tenantId: "",
        selectedProvider,
      })
    );
  };

  const handleYes = () => {
    dispatch(
      updateSACasinoGamesStatusStart({
        data: {
          code: "CASINO_GAME",
          casinoGameId: casinoGameId,
          status,
        },
        limit,
        pageNo: page,
        casinoCategoryId: selectedSubCategoryId,
        search,
        isActive: active,
        tenantId: "",
        selectedProvider,
      })
    );
    setStatusShow(false);
  };
  const updateCategory = (data, { casinoGameId }) =>
    dispatch(
      updateCasinoStart({
        data: {
          ...data,
          casinoGameId,
        },
        code: "CASINO_GAME",
        limit,
        pageNo: page,
        search,
      })
    );

  const createCategory = (data) =>
    dispatch(
      createCasinoStart({
        data,
        code: "CASINO_GAME",
        limit,
        pageNo: page,
        casinoCategoryId: selectedSubCategoryId,
        search,
        isActive: active,
        tenantId: "",
        selectedProvider,
      })
    );

  const getCasinoCategories = () => {
    dispatch(getSuperAdminGameCategoryStart({ categoryType: "featured" }))
  }

  useEffect(() => {
    dispatch(
      getSuperAdminGameSubCategoryStart({
        limit: "",
        pageNo: "",
        gameCategoryId: "",
        search: "",
        isActive: "",
        tenantId: "",
      })
    );
    dispatch(getAllCasinoProvidersStart({ limit: "", pageNo: "", search: "" }));
    getCasinoCategories()
  }, []);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (!isInitialRender) {
        if (page === 1) {
          dispatch(
            getAllCasinoGamesStart({
              limit,
              pageNo: page,
              casinoCategoryId: selectedSubCategoryId,
              search,
              isActive: active,
              tenantId: "",
              selectedProvider,
              bonusFilter,
            })
          );
        } else {
          setPage(1);
        }
      }
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [search]);

  const onhanldereset = () => {
    setSearch("");
    setActive("");
    setBonusFilter("");
    setPage(1)
  }

  useEffect(() => {
    setPage(1);
    dispatch(
      getAllCasinoGamesStart({
        limit,
        pageNo: page,
        casinoCategoryId: selectedSubCategoryId,
        search,
        isActive: active,
        tenantId: "",
        selectedProvider,
        bonusFilter,
      })
    );
  }, [limit, active, selectedSubCategoryId, selectedProvider, bonusFilter]);

  useEffect(() => {
    !isInitialRender &&
      dispatch(
        getAllCasinoGamesStart({
          limit,
          pageNo: page,
          casinoCategoryId: selectedSubCategoryId,
          search,
          isActive: active,
          tenantId: "",
          selectedProvider,
          bonusFilter,
        })
      );
  }, [page]);

  const handleClose = () => setShow(false);
  const handleShow = (type, data) => {
    setType(type);
    setData(data);
    setShow(true);
  };

  const handlePopular = ({ data, isPopular, from }) => {
    if (isPopular) {
      dispatch(
        handleSuperAdminPopularGameStart({
          data: {
            gameId: data?.casinoPopularId,
            isPopular: false,
          },
          from,
          limit,
          pageNo: page,
          casinoCategoryId: selectedSubCategoryId,
          search,
          isActive: active,
          tenantId: "",
          selectedProvider,
        })
      );
      setPopularModal({
        isOpen: false,
        title: "",
        subTtitle: "",
        data: ""

      })
    } else {
      dispatch(
        handleSuperAdminPopularGameStart({
          data: {
            gameId: data?.casinoPopularId,
            isPopular: true,
          },
          from,
          limit,
          pageNo: page,
          casinoCategoryId: selectedSubCategoryId,
          search,
          isActive: active,
          tenantId: "",
          selectedProvider,
        })
      );
      setPopularModal({
        isOpen: false,
        title: "",
        subTtitle: "",
        data: ""

      })
    }
  };

  const handleNewGame = ({ data, newKey, from }) => {
    dispatch(
      handleSuperAdminPopularGameStart({
        data: {
          gameId: data?.casinoPopularId,
          newKey: newKey ? false : true,
        },
        from,
        limit,
        pageNo: page,
        casinoCategoryId: selectedSubCategoryId,
        search,
        isActive: active,
        tenantId: "",
        selectedProvider,
      })
    );
  };

  const handleActive = ({ data }) => {
    dispatch(
      updateStatusStart({
        data: data,
        limit,
        pageNo: page,
        casinoCategoryId: selectedSubCategoryId,
        search,
        isActive: active,
        tenantId: "",
        selectedProvider,
      })
    );
  };



  const [thumbnailModal, setThumbnailModal] = useState(false);
  const [selectedGameForThumbnail, setSelectedGameForThumbnail] =
    useState(null);
  const [thumbnailUrl, setThumbnailUrl] = useState("");
  const [thumbnailPreview, setThumbnailPreview] = useState("");

  const handleThumbnailModalOpen = (game) => {
    setSelectedGameForThumbnail(game);

    const initialUrl = game?.thumbnailUrl?.evolutionImage
      ? process.env.REACT_APP_S3_URL + "/" + game?.thumbnailUrl?.evolutionImage
      : game?.thumbnailUrl
        ? game?.thumbnailUrl["XL"]
        : process.env.REACT_APP_EVOLUTION_URL + game?.thumbnailUrl["XL"];
    setSelectedCasinoGameId(game.casinoGameId);
    setThumbnailUrl(initialUrl);
    setThumbnailPreview(initialUrl);
    setThumbnailModal(true);
  };

  const handleThumbnailModalClose = () => {
    setThumbnailModal(false);
    setSelectedGameForThumbnail(null);
    setThumbnailUrl("");
    setThumbnailPreview("");
  };

  const handleThumbnailUrlChange = (e) => {
    setThumbnailUrl(e.target.value);
  };

  const handlePreviewThumbnail = () => {
    if (thumbnailUrl.trim()) {
      setThumbnailPreview(thumbnailUrl);
    }
  };

  const handlePopularYes = () => {
    console.log("enter")
  }

  const handleUpdateThumbnail = async () => {
    if (!thumbnailUrl.trim() || !selectedGameForThumbnail) {
      return;
    }

    try {
      dispatch(
        updateGameThumbnailURLStart({
          data: {
            thumbnailUrl,
            gameId: selectedCasinoGameId,
          },
          onSuccess: () => {
            setThumbnailModal(false);

            dispatch(
              getAllCasinoGamesStart({
                limit,
                pageNo: page,
                casinoCategoryId: selectedSubCategoryId,
                search,
                isActive: active,
                tenantId: "",
                selectedProvider,
              })
            );
          },
        })
      );
    } catch (error) {
      console.error("Error updating thumbnail:", error);
    }
  };

  return {
    limit,
    page,
    selectedSubCategoryId,
    show,
    data,
    type,
    statusShow,
    setLimit,
    setPage,
    setSelectedSubCategoryId,
    setStatusShow,
    gameSubCategory,
    casinoGamesData,
    totalPages,
    handleStatusShow,
    handleYes,
    handleClose,
    handleShow,
    getCategoryName,
    loading: casinogameLoading,
    search,
    setSearch,
    active,
    setActive,
    status,
    getProviderName,
    navigate,
    selectedProvider,
    setSelectedProvider,
    name,
    data,
    type,
    createCategory,
    updateCategory,
    handleDeleteItems,
    handlePopular,
    handleNewGame,
    handleActive,
    casinoBonusModal,
    setCasinoBonusModal,
    selectedCasinoGameId,
    setSelectedCasinoGameId,
    bonusFilter,
    setBonusFilter,
    thumbnailModal,
    setThumbnailModal,
    selectedGameForThumbnail,
    thumbnailUrl,
    thumbnailPreview,
    handleThumbnailModalOpen,
    handleThumbnailModalClose,
    handleThumbnailUrlChange,
    handlePreviewThumbnail,
    handleUpdateThumbnail,
    onhanldereset,
    setImageModal,
    imageModal,
    setPopularModal,
    popularModal,
    categoryDropdownOptions,
    handleUpdateCategoryChange,
    selectedCategoryOption,
    isOpenAssignCategoryModal, setIsOpenAssignCategoryModal,
    onSubmitAddCasinoGameCategory,
    loadingAddCategory,
    setSelectedctegoryOptions,
    isEnanbleAssignCategory,
    totalCount
  };
};

export default useCasinoGamesListing;
